/** Subproject or helpdesk task kind to load */
export enum SubsKindEnum {
  /** All entities */
  ALL = 'ALL',
  /** Active entities */
  ACTIVE = 'ACTIVE',
  /** Done entities */
  DONE = 'DONE',
}
